
import { useState } from 'react';
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { ImageOff } from "lucide-react";

interface ArticleHeaderProps {
  title: string;
  topic: string;
  date: string;
  readingTime: number;
  category: { name: string } | null;
  imageUrl: string | null;
}

export default function ArticleHeader({
  title,
  topic,
  date,
  readingTime,
  category,
  imageUrl
}: ArticleHeaderProps) {
  const [imageError, setImageError] = useState<boolean>(false);

  return (
    <div className="mb-10">
      {imageUrl && !imageError ? (
        <div className="w-full mb-8">
          <AspectRatio ratio={16/9} className="overflow-hidden rounded-lg">
            <img 
              src={imageUrl} 
              alt={title} 
              className="w-full h-full object-cover" 
              onError={() => setImageError(true)}
            />
          </AspectRatio>
        </div>
      ) : imageUrl && imageError ? (
        <div className="w-full mb-8">
          <AspectRatio ratio={16/9} className="overflow-hidden rounded-lg bg-gray-800/50 flex items-center justify-center">
            <div className="flex flex-col items-center text-gray-400">
              <ImageOff className="h-12 w-12 mb-2" />
              <span>Image could not be loaded</span>
            </div>
          </AspectRatio>
        </div>
      ) : null}
      
      <div className="flex items-center gap-2 mb-4">
        <span className="text-sm text-gray-400">
          {new Date(date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
        </span>
        {category && (
          <>
            <span className="text-gray-500">•</span>
            <span className="text-sm text-blue-400">{category.name}</span>
          </>
        )}
        <span className="text-gray-500">•</span>
        <span className="text-sm text-gray-400">{readingTime} min read</span>
      </div>
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 font-heading leading-tight">{title}</h1>
      <div className="text-xl text-gray-300 mb-8">{topic}</div>
    </div>
  );
}
